var map = {
	"./anchorUp.svg": 3402,
	"./arrow.svg": 7944,
	"./arrowCircle.svg": 4395,
	"./arrowLeft.svg": 3053,
	"./arrowUp.svg": 6586,
	"./backCircle.svg": 6867,
	"./close.svg": 899,
	"./closeCircle.svg": 8661,
	"./cursor.svg": 8428,
	"./factoriesSignature.svg": 2387,
	"./foodSignature.svg": 8647,
	"./hand.svg": 657,
	"./housingSignature.svg": 7385,
	"./infoCircle.svg": 3131,
	"./logo.svg": 6691,
	"./logoErrorScreen.svg": 6748,
	"./logoRotateDeviceScreen.svg": 4786,
	"./militarySignature.svg": 9919,
	"./northArrow.svg": 2319,
	"./notification.svg": 1477,
	"./pause.svg": 8172,
	"./play.svg": 4846,
	"./roadsSignature.svg": 5956,
	"./smallArrowLeft.svg": 3551,
	"./smallArrowRight.svg": 8862,
	"./warning.svg": 4273,
	"./waterSignature.svg": 8106,
	"svgs/anchorUp.svg": 3402,
	"svgs/arrow.svg": 7944,
	"svgs/arrowCircle.svg": 4395,
	"svgs/arrowLeft.svg": 3053,
	"svgs/arrowUp.svg": 6586,
	"svgs/backCircle.svg": 6867,
	"svgs/close.svg": 899,
	"svgs/closeCircle.svg": 8661,
	"svgs/cursor.svg": 8428,
	"svgs/factoriesSignature.svg": 2387,
	"svgs/foodSignature.svg": 8647,
	"svgs/hand.svg": 657,
	"svgs/housingSignature.svg": 7385,
	"svgs/infoCircle.svg": 3131,
	"svgs/logo.svg": 6691,
	"svgs/logoErrorScreen.svg": 6748,
	"svgs/logoRotateDeviceScreen.svg": 4786,
	"svgs/militarySignature.svg": 9919,
	"svgs/northArrow.svg": 2319,
	"svgs/notification.svg": 1477,
	"svgs/pause.svg": 8172,
	"svgs/play.svg": 4846,
	"svgs/roadsSignature.svg": 5956,
	"svgs/smallArrowLeft.svg": 3551,
	"svgs/smallArrowRight.svg": 8862,
	"svgs/warning.svg": 4273,
	"svgs/waterSignature.svg": 8106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6984;